import React, {useEffect, useState} from 'react';
import {Modal} from "antd";
import {Leave_Type} from "../../../../../constant/constant";
import '../../../../../styles/component/leave-audit-detail.scss';
import server from "../../../../../server";
import {IAuditInfo, IEntitlementList, ILeaveAuditState} from "../leave-entitlement.types";
import Locale from "../../../../../core/locale/locale";
import dayjs from "dayjs";

interface ILeaveEntitlementAuditProps {
    record: IEntitlementList
}

const LeaveEntitlementAudit = (props: ILeaveEntitlementAuditProps) => {
    const {record} = props;
    const [leaveAuditState, setLeaveAuditState] = useState<ILeaveAuditState>({
        employeeName: '',
        employeeId: '',
        leaveType: '',
        unit: 0,
        auditDetails: [],
        modalConfig: {open: false}
    });

    useEffect(() => {
        setLeaveAuditState({
            employeeName: record.name || '',
            employeeId: record.employeeId || '',
            leaveType: Leave_Type[record.leaveType as keyof typeof Leave_Type] || '',
            unit: record.unit || 0,
            auditDetails: [],
            modalConfig: {
                open: true
            }
        });
        getAuditInfo(record.id);
    }, [record]);

    const getTime = (date: string) => (
        new Date(date).toLocaleTimeString("en-US")
    )

    async function getAuditInfo(entitlementId: string) {
        if (!entitlementId) {
            return
        }
        try {
            const response = await server.leave.entitlement.getAudit(entitlementId);
            setLeaveAuditState((prev) => ({
                ...prev,
                auditDetails: response
            }));

        } catch (e) {

        }
    }

    function handleModalClose() {
        setLeaveAuditState((prev) => ({
            ...prev,
            modalConfig: {
                open: false
            }
        }));
    }

    return (
        <Modal
            title={'Entitlement Audit'}
            className={'hrms-app modal-audit'}
            open={leaveAuditState?.modalConfig.open}
            onCancel={handleModalClose}
            footer={<></>}
        >
            <div className={'audit-container'}>
                <div className={'details-section'}>
                    <div className={"leave-audit leave-entitlement-info-grid "}>
                        <div className={'leave-audit info-cell'}>
                            <label className={'leave-audit cell-label'}>Employee Name</label>
                            <span className={'leave-audit cell-value'}>{leaveAuditState.employeeName}</span>
                        </div>
                        <div className={'leave-audit info-cell'}>
                            <label className={'leave-audit cell-label'}>Leave Type</label>
                            <span className={'leave-audit cell-value'}>{leaveAuditState.leaveType}</span>
                        </div>
                        <div className={'leave-audit info-cell'}>
                            <label className={'leave-audit cell-label'}>Unit</label>
                            <span className={'leave-audit cell-value'}>{leaveAuditState.unit}</span>
                        </div>
                    </div>
                </div>
                <div className={'section-divider'}/>
                <div className={'audit-details-section'}>
                    <h4 className={'section-title'}>Audit Details</h4>
                    <div className={'audit-timeline'}>
                        {leaveAuditState?.auditDetails.map((audit: IAuditInfo, index: number) => {
                            return (
                                <div key={index} className={'audit-item'}>
                                    <div className={'audit-item-header'}>
                                <span className={'status-badge default'}>
                                    {audit.auditInfo.createdOn ? dayjs(audit.auditInfo.createdOn).format(Locale.displayDateWithMonth) : "-"}
                                </span>
                                        <span className={'audit-time'}>
                                            {getTime(audit.auditInfo.createdOn)}
                                        </span>
                                    </div>
                                    <div className={'audit-item-content'}>
                                        <div className={'audit-field'}>
                                            <label className={'field-label'}>Action by</label>
                                            <span className={'field-value'}>{audit.auditInfo.createdBy}</span>
                                        </div>
                                        <div className={'audit-field'}>
                                            <label className={'field-label'}>Unit Assigned</label>
                                            <span className={'field-value'}>{audit.unit}</span>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default LeaveEntitlementAudit
